import { Component, Input, OnInit } from '@angular/core';
import { isTipoPessoaFisica, isTipoPessoaJuridica, isTipoPessoaCentralCompras } from '../../pessoa-tipo';

interface Config {
    isFisica: boolean;
    isJuridica: boolean;
    isCentralCompras: boolean;
}

@Component({
    selector: 'sgt-pessoa-tipo-badge',
    templateUrl: './pessoa-tipo-badge.component.html',
    styleUrls: ['./pessoa-tipo-badge.component.less']
})
export class PessoaTipoBadgeComponent implements OnInit {
    config: Config;

    /** Tipo da pessoa */
    @Input() tipo: number;
    /** Quantidade de participantes quando for o tipo Central de Compras */
    @Input() quantidadeParticipantesCentralCompras: number = null;

    ngOnInit(): void {
        this.setConfig();
    }

    private setConfig() {
        this.config = {
            isFisica: isTipoPessoaFisica(this.tipo),
            isJuridica: isTipoPessoaJuridica(this.tipo),
            isCentralCompras: isTipoPessoaCentralCompras(this.tipo)
        };
    }
}
